<template>
  <div>
    <form autocomplete="off"
          class="mb-2 p-3"
          novalidate
          @submit.prevent="onSubmitFn()">
      <div class="form-group">
        <label for="livro">
          Qual tipo de documento deseja adicionar?
        </label>

        <div class="d-block"
             :class="{ 'was-validated': errors.first('livroOuRegistro') }">
          <div class="custom-control custom-radio custom-control-inline">
            <input id="livro"
                   v-model="tipoPesquisa"
                   v-validate="'required'"
                   class="custom-control-input"
                   name="livro"
                   required
                   type="radio"
                   :value="'LIVRO'">

            <label class="custom-control-label"
                   for="livro">
              Livro
            </label>
          </div>

          <div class="custom-control custom-radio custom-control-inline">
            <input id="registro"
                   v-model="tipoPesquisa"
                   v-validate="'required'"
                   class="custom-control-input"
                   name="registro"
                   required
                   type="radio"
                   :value="'REGISTRO'">

            <label class="custom-control-label"
                   for="registro">
              Registro
            </label>
          </div>

          <small v-if="errors.has('livroOuRegistro')"
                 class="d-block invalid-feedback">
            {{ errors.first('livroOuRegistro') }}
          </small>
        </div>

        <label class="mt-3 pl-0">
          Escolha o tipo de livro/registro <span class="text-obrigatorio">(Obrigatório)</span>
        </label>

        <div class="d-flex jus mt-2 pl-0">
          <div class="col-7">
            <div v-for="item in typeList"
                 :key="item.valor"
                 class="radioBox d-inline-flex align-items-center mr-3"
                 :class="{ active: pesquisa.tipoLivro === item.valor }"
                 @click="pesquisa.tipoLivro = item.valor">
              <label :key="item.id"
                     class="radioBox_btn w-100 text-center position-relative"
                     :for="item.text">
                <div v-if="item.text === 'Religioso'">
                  <svg class="radioBox_iconReligioso icon--md mb-1"
                       role="presentation">
                    <use :xlink:href="'#' + item.icon.id" />
                  </svg>
                </div>

                <div v-else>
                  <svg class="radioBox_icon icon--md"
                       role="presentation">                   
                    <use :xlink:href="'#' + item.icon.id" />
                  </svg>
                </div>

                <input :id="item.text"
                       v-model="pesquisa.tipoLivro"
                       v-validate="'required'"
                       class="radioBox_input position-absolute"
                       name="typeFilter"
                       required
                       type="radio"
                       :value="item.valor">

                <div v-if="item.text === 'Religioso'">
                  <span class="radioBox_preTitle w-100 d-inline-block small">
                    {{ item.preText }}
                  </span>

                  <span class="radioBox_titleReligioso w-100 d-inline-block small">
                    {{ item.text }}
                  </span>
                </div>

                <div v-else>
                  <span class="radioBox_title w-100 d-inline-block">
                    {{ item.text }}
                  </span>
                </div>
              </label>
            </div>

            <small v-if="errors.has('typeFilter')"
                   class="d-block invalid-feedback">
              {{ errors.first('typeFilter') }}
            </small>
          </div>
          <div v-if="tipoPesquisa === 'REGISTRO'">
            <label class="font-weight-bold">Listar registros</label>
            <b-form-radio-group id="radio-slots"
                                v-model="pesquisa.statusImagem"
                                :options="optionsImage"
                                :aria-describedby="ariaDescribedby"
                                name="radio-options-slots" />
          </div>
        </div>
      </div>
      
      <div v-if="tipoPesquisa">
        <div v-if="tipoPesquisa === 'LIVRO'">
          <div class="row">
            <div class="col-12 numLivro">
              <div class="form-group">
                <label for="numLivro">
                  Núm. do livro
                </label>

                <input id="numLivro"
                       v-model="pesquisa.numLivro"
                       class="form-control form-control-sm"
                       :class="{ 'is-invalid': errors.has('numLivro') }"
                       name="numLivro"
                       placeholder="0000"
                       min="1"
                       type="number">

                <small v-if="errors.has('numLivro')"
                       class="invalid-feedback">
                  {{ errors.first('numLivro') }}
                </small>
              </div>
            </div>

            <div class="d-inline-block">
              <button class="btn btn-outline-primary btn-sm btnListar mt-2rem ml-2"
                      type="submit">
                Listar
              </button>
            </div>
          </div>
        </div>

        <div v-if="tipoPesquisa === 'REGISTRO'">
          <div class="row">
            <div class="col-12 col-sm-4 form-group">            
              <label for="numLivro">
                Núm. do livro <span class="text-obrigatorio">(Obrigatório)</span>
              </label>

              <input id="numLivro"
                     v-model="pesquisa.numLivro"
                     v-validate="'required'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('numLivro') }"
                     required
                     name="numLivro"
                     placeholder="0000"
                     min="1"
                     type="number">

              <small v-if="errors.has('numLivro')"
                     class="invalid-feedback">
                {{ errors.first('numLivro') }}
              </small>
            </div>

            <div class="col-12 col-sm-4 form-group">
              <label for="numFolha">
                Núm. da folha
              </label>

              <input id="numFolha"
                     v-model="pesquisa.numFolha"
                     v-validate="'min_value:1'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('numFolha') }"
                     name="numFolha"
                     placeholder="0000"
                     min="1"
                     type="number">

              <small v-if="errors.has('numFolha')"
                     class="invalid-feedback">
                {{ errors.first('numFolha') }}
              </small>
            </div>

            <div class="col-12 col-sm-4 form-group">
              <label for="numRegistro">Registro</label>

              <input id="numRegistro"
                     v-model="pesquisa.numRegistro"
                     v-validate="'min_value:1'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('numRegistro') }"
                     min="1"
                     name="numRegistro"
                     placeholder="0000"
                     type="number">

              <small v-if="errors.has('numRegistro')"
                     class="invalid-feedback">
                {{ errors.first('numRegistro') }}
              </small>
            </div>
          </div>

          <div class="row">
            <div class="col-12 dataRegistro form-group">
              <label for="dataRegistroInicio">
                Data de Registro
              </label>

              <input id="dataRegistroInicio"
                     v-model="pesquisa.dataRegistroInicio"
                     v-mask="'##/##/####'"
                     v-validate="{
                       required: !!pesquisa.dataRegistroFim,
                       date_format: 'dd/MM/yyyy',
                       date_between: ['01/01/1500', limitDate],
                       max_date: new Date()
                     }"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('dataRegistroInicio') }"
                     maxlength="10"
                     name="dataRegistroInicio"
                     placeholder="00/00/0000"
                     type="text">

              <small v-if="errors.has('dataRegistroInicio')"
                     class="invalid-feedback">
                {{ errors.first('dataRegistroInicio') }}
              </small>
            </div>
            
            <label class="mt-labelAte">
              até
            </label>

            <div class="col-12 dataRegistro mt-2rem form-group">
              <input id="dataRegistroFim"
                     v-model="pesquisa.dataRegistroFim"
                     v-mask="'##/##/####'"
                     v-validate="{
                       required: !!pesquisa.dataRegistroInicio,
                       date_format: 'dd/MM/yyyy',
                       date_between: ['01/01/1500', limitDate],
                       max_date: new Date()
                     }"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('dataRegistroFim') }"
                     maxlength="10"
                     name="dataRegistroFim"
                     placeholder="00/00/0000"
                     type="text">

              <small v-if="errors.has('dataRegistroFim')"
                     class="invalid-feedback">
                {{ errors.first('dataRegistroFim') }}
              </small>
            </div>

            <div class="col-12 dataRegistro form-group">
              <label for="dataOcorridoInicio">
                Data Ocorrido
              </label>

              <input id="dataOcorridoInicio"
                     v-model="pesquisa.dataOcorridoInicio"
                     v-mask="'##/##/####'"
                     v-validate="{
                       required: !!pesquisa.dataOcorridoFim,
                       date_format: 'dd/MM/yyyy',
                       date_between: ['01/01/1500', limitDate],
                       max_date: new Date()
                     }"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('dataOcorridoInicio') }"
                     maxlength="10"
                     name="dataOcorridoInicio"
                     placeholder="00/00/0000"
                     type="text">

              <small v-if="errors.has('dataOcorridoInicio')"
                     class="invalid-feedback">
                {{ errors.first('dataOcorridoInicio') }}
              </small>
            </div>
            
            <label class="mt-labelAte">
              até
            </label>

            <div class="col-12 dataRegistro mt-2rem form-group">
              <input id="dataOcorridoFim"
                     v-model="pesquisa.dataOcorridoFim"
                     v-mask="'##/##/####'"
                     v-validate="{
                       required: !!pesquisa.dataOcorridoInicio,
                       date_format: 'dd/MM/yyyy',
                       date_between: ['01/01/1500', limitDate],
                       max_date: new Date()
                     }"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('dataOcorridoFim') }"
                     maxlength="10"
                     name="dataOcorridoFim"
                     placeholder="00/00/0000"
                     type="text">

              <small v-if="errors.has('dataOcorridoFim')"
                     class="invalid-feedback">
                {{ errors.first('dataOcorridoFim') }}
              </small>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-3 form-group">
              <label for="numRegistroInicial">
                Registro inicial
              </label>
              
              <input id="numRegistroInicial"
                     v-model="pesquisa.numRegistroInicial"
                     v-validate="'min_value:1'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('numRegistroInicial') }"
                     min="1"
                     name="numRegistroInicial"
                     placeholder="0000"
                     type="number">

              <small v-if="errors.has('numRegistroInicial')"
                     class="invalid-feedback">
                {{ errors.first('numRegistroInicial') }}
              </small>
            </div>

            <div class="col-12 col-sm-3 form-group">
              <label for="numRegistroFinal">
                Registro final
              </label>

              <input id="numRegistroFinal"
                     v-model="pesquisa.numRegistroFinal"
                     v-validate="'min_value:1'"
                     class="form-control form-control-sm"
                     :class="{ 'is-invalid': errors.has('numRegistroFinal') }"
                     min="1"
                     name="numRegistroFinal"
                     placeholder="0000"
                     type="number">
              
              <small v-if="errors.has('numRegistroFinal')"
                     class="invalid-feedback">
                {{ errors.first('numRegistroFinal') }}
              </small>
            </div>

            <div class="col-12 col-sm-2 form-group d-inline-block">
              <button class="btn btn-outline-primary btn-sm btnListar mt-2rem"
                      type="submit">
                Listar
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import moment from 'moment'
  
  // icons
  import obito from '@/assets/icons/flower.svg?sprite'
  import nasc from '@/assets/icons/baby-buggy.svg?sprite'
  import natimorto from '@/assets/icons/ribbon.svg?sprite'
  import casamento from '@/assets/icons/engagement.svg?sprite'
  import casamentoRegilioso from '@/assets/icons/calendar-heart.svg?sprite'
  
  export default {
    name: 'PesquisaLote',
    data () {
      return {
        // Tabela
        typeList: [
          {
            text: 'Nascimento',
            id: 1,
            valor: 'N',
            icon: nasc
          },
          {
            text: 'Casamento',
            id: 2,
            valor: 'C',
            icon: casamento
          },
          {
            preText: 'Casamento',
            text: 'Religioso',
            id: 3,
            valor: 'CR',
            icon: casamentoRegilioso
          },
          {
            text: 'Óbito',
            id: 4,
            valor: 'O',
            icon: obito
          },
          {
            text: 'Natimorto',
            id: 5,
            valor: 'NT',
            icon: natimorto
          }
        ],
        
        // Filtros pesquisa
        pesquisa: {
          tipoLivro: null,
          numLivro: null,
          numFolha: null,
          numRegistro: null,
          dataRegistroInicio: null,
          dataRegistroFim: null,
          dataOcorridoInicio: null,
          dataOcorridoFim: null,
          numRegistroInicial: null,
          numRegistroFinal: null,
          statusImagem: 'Todos' // Todos, Com imagem ou Sem imagem
        },
        selected: '',
        optionsImage: [
          { text: 'Todos', value: 'Todos' },
          { text: 'Sem imagem', value: 'Sem imagem' },
          { text: 'Com imagem', value: 'Com imagem' }
        ],
        tipoPesquisa: 'LIVRO', // LIVRO ou REGISTRO
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY')
      }
    },
    watch: {
      tipoPesquisa: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('changeTipoPesquisa', newVal)
        }
      }
    },
    methods: {
      onSubmitFn () {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$emit('recebeFiltrosPesquisa', {
              pesquisa: this.pesquisa,
              tipoPesquisa: this.tipoPesquisa
            })
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .radioBox {
    border: pxToRem(1) solid $color-gray-light;
    max-width: pxToRem(100);
    min-height: pxToRem(80);
    transition: background-color 0.15s linear, border-color 0.15s linear;
    width: 33%;
    cursor: pointer;

    &_input {
      height: 0;
      opacity: 0;
      width: 0;
    }

    &_icon {
      fill: $color-gray-light;
      margin-top: 0.3rem;
    }

    &_title {
      color: $color-gray-light;
      font-size: pxToRem(14);
      font-weight: 500;
      transition: color 0.15s linear;
      margin-top: 0.5rem;
    }

    &_iconReligioso {
      fill: $color-gray-light;
    }

    &_preTitle {
      position: absolute;
      top: 1.8rem;
      color: $color-gray-light;
      font-size: pxToRem(13);
      font-weight: 400;
      transition: color 0.15s linear;
    }

    &_titleReligioso {
      color: $color-gray-light;
      font-size: pxToRem(14);
      font-weight: 500;
      transition: color 0.15s linear;
      margin-top: 0.5rem;
    }

    &.active,
    &:hover {
      background-color: $color-logo;
      border-color: $color-logo;

      .radioBox_icon {
        fill: $color-white;
      }

      .radioBox_title {
        color: $color-white;
      }
    }
  }

  .numLivro {
    max-width: 45%;
  }

  .btnListar {
    width: 5rem;
  }

  .dataRegistro {
    max-width: 18%;
  }

  .mt-2rem {
    margin-top: 2rem;
  }

  .mt-labelAte {
    margin-top: 2.3rem;
  }

  .mb-2rem {
    margin-bottom: 2rem;
  }
  .text-obrigatorio {
    color: #8c231d;
  }
</style>
